import React from 'react';

import omit from 'lodash/omit';
import pick from 'lodash/pick';

import { classnames } from '@lumapps/classnames';
import { useDataAttributes } from '@lumapps/data-attributes';
import { getCustomClasses } from '@lumapps/utils/string/getCustomClasses';
import { INNER_SPACING_STYLES } from '@lumapps/widget-styles/constants';

import { useComputeStyles } from '../../hooks/useComputeStyles';
import * as types from '../../types';
import { SizeVariant } from '../../types';

import './index.scss';

type Props = Pick<types.Row, 'properties' | 'children'> & {
    path: string;
};

export const Row: React.FC<Props> = (props) => {
    const { properties, path, children } = props;

    const { get: getDataAttributes } = useDataAttributes('layout');
    const computedStyles = useComputeStyles(properties?.style, true);

    // Inner spacing should apply to the inner div only.
    const style = omit(computedStyles, INNER_SPACING_STYLES);
    const wrapperStyle = pick(computedStyles, INNER_SPACING_STYLES);

    const className = classnames('row', getCustomClasses(properties?.class, 'component-row--'));

    const sizeVariant: SizeVariant =
        properties?.sizeVariant || (properties?.fullWidth && SizeVariant.FULL_WIDTH) || SizeVariant.REGULAR;

    return (
        <div {...getDataAttributes({ element: path })} id={properties?.id} className={className} style={style}>
            <div className={classnames('row-wrapper', `row-wrapper--is-${sizeVariant}`)} style={wrapperStyle}>
                {children}
            </div>
        </div>
    );
};

Row.displayName = 'Row';
